export const ADMIN_AUTH_STORAGE_KEY = 'salzburg_admin_authenticated'
export const ADMIN_TOKEN_KEY = 'salzburg_admin_token'
export const ADMIN_REFRESH_TOKEN_KEY = 'salzburg_admin_refresh_token'
export const ADMIN_USER_KEY = 'salzburg_admin_user'

export const isAdminAuthenticated = (): boolean => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY)

  return (
    localStorage.getItem(ADMIN_AUTH_STORAGE_KEY) === 'true' &&
    Boolean(token) &&
    token !== 'demo_admin_token_active'
  )
}

export const clearAdminSession = () => {
  localStorage.removeItem(ADMIN_AUTH_STORAGE_KEY)
  localStorage.removeItem(ADMIN_TOKEN_KEY)
  localStorage.removeItem(ADMIN_REFRESH_TOKEN_KEY)
  localStorage.removeItem(ADMIN_USER_KEY)
}

// Compatibility alias for existing logout/session-cleanup imports.
export const logoutTemporaryAdmin = clearAdminSession